import { Constantes } from '@/services/helper/constantes';

/*
 * Relatórios da Central de Vagas (seg_menu, serviço 26): "Vagas e lista de espera"
 * (prematricula_relatorio_vagas) e "Estatísticas" (estatistica_central_vagas). "Estudantes
 * matriculados" (prematricula_relatorio_matriculados) está em ../inscricoes/routes.ts.
 *
 * "Negativa de Vagas" e "Estudantes com Liminares" eram da Central de Vagas legada (ListaEspera)
 * e foram removidos; os itens de menu deles foram reaproveitados para os relatórios acima.
 */
export default [
  {
    // Req. 169: o painel interno de vagas e lista de espera (as contas dos dados abertos).
    description: 'Vagas e lista de espera',
    path: '/centralvagas/relatorios/vagas-lista-espera',
    name: 'prematricula_relatorio_vagas',
    component: () => import('@/views/centralvagas/prematricula/PainelVagas.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
      titulo: 'Vagas e lista de espera',
    },
    goesToMenu: true,
  },
  {
    // Dashboard da pré-matrícula por processo; em Cachoeirinha, as estatísticas dela.
    description: 'Estatísticas',
    path: '/centralvagas/relatorios/estatistica',
    name: 'estatistica_central_vagas',
    component: () => Constantes.PREMATRICULA_POR_PROCESSO
      ? import('@/views/centralvagas/prematricula/EstatisticasPreMatricula.vue')
      : import('@/views/centralvagas/relatorios/estatistica_cachoeirinha.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
      titulo: 'Estatísticas',
    },
    goesToMenu: true,
  },
  {
    description: 'Estatísticas',
    path: '/centralvagas/relatorios/estatistica/cachoeirinha',
    name: 'estatistica_central_vagas_cachoeirinha',
    component: () => import('@/views/centralvagas/relatorios/estatistica_cachoeirinha.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]
